<template>
  <v-container grid-list-md class="booking-statistics">
    <v-layout wrap mt-3>
      <v-flex xs12 sm12 md12 lg6>
        <v-card :class="[{'low-profile': hotel !== undefined}]" style="padding: 5px">
          <v-card-text style="padding: 5px">
            <div class="apex-charts-title">Prognose für den Umsatz</div>
            <apexcharts ref="forecastChart" type=bar height=250
                        :options="forecast.chartOptions" :series="forecast.series" />
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12 md12 lg6>
        <v-card :class="[{'low-profile': hotel !== undefined}]" style="padding: 5px">
          <v-card-text style="padding: 5px">
            <div class="apex-charts-title">Umsätze nach Abreisen Vergleich</div>
            <apexcharts ref="differenceChart" type=bar height=250
                        :options="difference.chartOptions" :series="difference.series" />
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12 md12 lg6 xl4>
        <v-card :class="[{'low-profile': hotel !== undefined}]" style="padding: 5px">
          <v-card-text style="padding: 5px">
            <div class="apex-charts-title relative">Herkunftsländer in {{getCurrentYear()}}</div>
            <apexcharts ref="landsChart" type=pie width="100%" height="330px"
                        :options="lands.chartOptions" :series="lands.series" />
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12 md12 lg6 xl4>
        <v-card :class="[{'low-profile': hotel !== undefined}]" style="padding: 5px">
          <v-card-text style="padding: 5px">
            <div class="apex-charts-title relative">Buchungsplattformen in {{getCurrentYear()}}</div>
            <apexcharts ref="enginesChart" type=pie width="100%" height="330px"
                        :options="engines.chartOptions" :series="engines.series" />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  const Apexcharts = () => import(/* webpackChunkName: "apexcharts" */ 'vue-apexcharts');

  export default {
    name: 'BookingStatistics',
    components: {
      Apexcharts
    },
    props: {
      hotel: undefined
    },
    data() {
      return {
        initialized: false,
        id: undefined,
        forecast: {
          series: [],
          chartOptions: {
            xaxis: {
              categories: []
            },
            yaxis: {
              title: {
                text: 'Umsatz',
                style: {
                  fontSize: '14px'
                }
              },
              labels: {
                formatter: (value) => { return Math.round(value).toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, '$&,') + ' €' },
              }
            },
            tooltip: {
              y: {
                formatter: val => "€ " + Number(val).toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, '$&,')
              }
            },
            dataLabels: {
              enabled: false,
              formatter: val => "€ " + Number(val).toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, '$&,'),
              textAnchor: 'start',
              style: {
                colors: ['#000']
              }
            },
            noData: {
              text: 'Es sind noch keine Buchungsdaten vorhanden.'
            }
          }
        },
        difference: {
          series: [],
          chartOptions: {
            xaxis: {
              categories: []
            },
            yaxis: {
              title: {
                text: 'Umsatz',
                style: {
                  fontSize: '14px'
                }
              },
              labels: {
                formatter: (value) => { return Math.round(value).toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, '$&,') + ' €' }
              }
            },
            tooltip: {
              y: {
                formatter: val => "€ " + Number(val).toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, '$&,')
              }
            },
            dataLabels: {
              enabled: false,
              formatter: val => "€ " + Number(val).toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, '$&,'),
              textAnchor: 'start',
              style: {
                colors: ['#000']
              }
            },
            noData: {
              text: 'Es sind noch keine Buchungsdaten vorhanden.'
            }
          }
        },
        lands: {
          series: [],
          chartOptions: {
            labels: [],
            colors: ['#2E93fA', '#66DA26', '#00e397', '#6a787a',
              '#E91E63', '#FF9800', '#d800e3', '#0bfcff',
              '#00ff04', '#5b1ce6'
            ],
            responsive: [{
              breakpoint: 480,
              options: {
                legend: {
                  position: 'bottom'
                }
              }
            }],
            noData: {
              text: 'Es sind noch keine Buchungsdaten vorhanden.'
            }
          }
        },
        engines: {
          series: [],
          chartOptions: {
            labels: [],
            colors: ['#2E93fA', '#66DA26', '#00e397', '#6a787a',
              '#E91E63', '#FF9800', '#d800e3', '#0bfcff',
              '#00ff04', '#5b1ce6'
            ],
            responsive: [{
              breakpoint: 480,
              options: {
                legend: {
                  position: 'bottom'
                }
              }
            }],
            noData: {
              text: 'Es sind noch keine Buchungsdaten vorhanden.'
            }
          }
        }
      };
    },
    mounted() {
      if (this.$auth.check('ROLE_ADMIN') || this.$auth.check('ROLE_MODERATOR')) {
        if (!this.initialized) {
          this.id = this.hotel.id;
          this.fetchBookingSummary();
        }
        this.globalEvents.$on('hotelSelected', (hotel) => {
          this.id = hotel.id;
          this.fetchBookingSummary();
        });
      } else {
        this.fetchBookingSummary();
      }
    },
    methods: {
      fetchBookingSummary() {
        this.forecast.series = [];
        this.difference.series = [];
        this.lands.series = [];
        this.engines.series = [];
        if (this.hotel !== undefined) {
          this.$http.get('statistic/booking/'.concat(this.id))
            .then((data) => {
              this.prepareBookingSummary(data.body)
            });
        } else {
          const statistics = this.$store.getters.getBookingSummary;
          if (statistics.summary === undefined || statistics.updated === undefined
            || this.$moment(statistics.updated).isBefore(this.$moment().endOf('day'))) {
            this.$http.get('statistic/booking').then((data) => {
              const statistic = {
                booking: {
                  summary: data.body
                }
              };
              this.$store.dispatch('setBookingSummary', { statistic: statistic });
              this.prepareBookingSummary(this.$store.getters.getBookingSummary.summary);
            });
          } else {
            this.prepareBookingSummary(this.$store.getters.getBookingSummary.summary);
          }
        }
        this.initialized = true;
      },
      prepareBookingSummary(statistics) {
        if (statistics.forecast !== undefined) {
          const categories = [];
          const seriesList = [];
          for (let i = 0; i < statistics.forecast.length; i += 1) {
            const forecast = statistics.forecast[i];
            const series = {
              name: forecast.name,
              data: []
            };
            for (let j = 0; j < forecast.data.length; j += 1) {
              const data = forecast.data[j];
              series.data.push(data.value);
              if (i === 0) {
                categories.push(data.date);
              }
            }
            seriesList.push(series);
          }
          if (this.hasSeriesData(seriesList)) {
            this.forecast.series = seriesList;
          }
          if (this.$refs.forecastChart !== undefined) {
            this.$refs.forecastChart.updateOptions({
              xaxis: {
                categories: categories
              },
            });
          } else {
            this.forecast.chartOptions.xaxis = {
              categories: categories
            };
          }
        }

        if (statistics.difference !== undefined) {
          const categories = [];
          const seriesList = [];
          for (let i = 0; i < statistics.difference.length; i += 1) {
            const difference = statistics.difference[i];
            const series = {
              name: difference.name,
              data: []
            };
            for (let j = 0; j < difference.data.length; j += 1) {
              const data = difference.data[j];
              series.data.push(data.value);
              if (i === 0) {
                categories.push(data.date);
              }
            }
            // series.data.reverse();
            seriesList.push(series);
          }
          if (this.hasSeriesData(seriesList)) {
            this.difference.series = seriesList;
          }
          if (this.$refs.differenceChart !== undefined) {
            this.$refs.differenceChart.updateOptions({
              xaxis: {
                categories: categories
              },
            });
          } else {
            this.difference.chartOptions.xaxis = {
              categories: categories
            };
          }
        }

        if (statistics.lands !== undefined) {
          const lands = [];
          for (let i = 0; i < statistics.lands.length; i += 1) {
            const land = statistics.lands[i];
            lands.push(land.country);
            this.lands.series.push(land.count);
          }

          if (this.$refs.landsChart !== undefined) {
            this.$refs.landsChart.updateOptions({
              labels: lands
            });
          } else {
            this.lands.chartOptions.labels = lands;
          }
        }

        if (statistics.engines !== undefined) {
          const engines = [];
          for (let i = 0; i < statistics.engines.length; i += 1) {
            const engine = statistics.engines[i];
            engines.push(engine.engine);
            this.engines.series.push(engine.count);
          }

          if (this.$refs.enginesChart !== undefined) {
            this.$refs.enginesChart.updateOptions({
              labels: engines
            });
          } else {
            this.engines.chartOptions.labels = engines;
          }
        }
      },
      getCurrentYear() {
        return this.$moment().format('YYYY');
      },
      hasSeriesData(seriesList) {
        let hasData = false;
        for (let i = 0; i < seriesList.length; i += 1) {
          const series = seriesList[i];
          for (let j = 0; j < series.data.length; j += 1) {
            if (series.data[j] !== null) {
              hasData = true;
            }
          }
        }
        return hasData;
      }
    }
  };
</script>

<style lang="scss">
  @import "../../assets/scss/variables";
  .booking-statistics {
    padding: 0;
    .low-profile {
      box-shadow: none;
    }
    .apexcharts-menu-icon {
      color: $primary-text;
      svg {
        fill: $primary-text;
      }
      &:hover {
        color: $primary;
        svg {
          fill: $primary;
        }
      }
    }
    .apexcharts-menu-item.exportSVG {
      display: none;
    }
    .apexcharts-xaxistooltip, .apexcharts-tooltip {
      background: url('../../assets/images/crossword.png');
      .apexcharts-xaxistooltip-text {
        font-weight: 600;
      }
    }
    .apex-charts-title {
      color: $primary-text;
      font-family: 'Open Sans', sans-serif;
      font-size: 18px;
      position: absolute;
      top: 0;
      left: 15px;

      &.relative {
        position: relative;
      }
    }
  }

</style>
